import React, { memo, useEffect, useState } from "react";
import {
  Autocomplete,
  Button,
  Checkbox,
  FormControl,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { getData, storeData, callChoice } from "../../utils/GlobalHelper";
import HeaderPage from "../../components/HeaderPage/Index";
import Loading from "../../components/loading/loading";
import { isMobile } from "react-device-detect";
import BoxLeftContent from "../../components/BoxLeftContent/BoxLeftContent";
import HeaderRight from "../../components/BoxRightContent/HeaderRight";
import GlobalApi from "../../utils/GlobalApi";
import Configs from "../../constants/Configs";
import DialogWait from "../../components/CustomDialog/DialogWait";
import { API_CODE_SUCCESS } from "../../constants/CommonConstant";
import clsx from "clsx";
import PanelScrollBar from "../../components/BoxRightContent/PanelScrollBar";
import { makeStyles } from "@mui/styles";
import { isEmpty } from "lodash";
import DialogCustoms from "../../components/CustomDialog/DialogCustoms";
const useStyle = makeStyles({
  font: {
    fontFamily: "DB Heavent",
  },
  content: {
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "var(----text-black)",
  },
});
const ProductsConsent = (props) => {
  const mb = isMobile ? 16 : 9;
  const classes = useStyle();
  const translations = getData("Translations");
  const HeaderManp = getData("HeaderManp");
  const [lang, setLang] = useState(getData("lang"));
  const [isLoading, setIsLoading] = useState(false);
  const [isModelWait, setIsModelWait] = useState(false);
  const [isModelWaitText, setIsModelWaitText] = useState({
    title: "",
    massage: "",
    btn: "กลับ",
  });
  const [isRead, setIsRead] = useState(false);
  const [checked, setChecked] = useState(false);
  const [consent, setConsent] = useState({
    checkboxText: "",
    termConText: "",
    titleText: "",
    btnOk: "",
    btnCancel: "",
    id: "",
    group: "",
    name: "",
  });
  const [isModal, setIsModal] = useState(false);
  const [valueModal, setValueModal] = useState({
    imgError: true,
    imgFinished: false,
    title: "",
    massage: "",
    btnPrimary: "",
  });
  const [dataProduct, setDataProduct] = useState([]);
  const [productSelected, setProductSelected] = useState([]);
  const [productSelectedDf, setProductSelectedDf] = useState([]);
  const [checkPost, setCheckPost] = useState(false);
  const [valueOption, setValueOption] = useState("");
  // const [valueCurrency, setValueCurrency] = useState("");
  const [strategic, setStrategic] = useState([]);
  // const [currency, setCurrency] = useState([]);
  const head_token = getData("HeaderManp")
    ? getData("HeaderManp")?.head_token
    : "";
  const [jumpPage, setJumpPage] = useState(false);
  const checkuserinfo = getData("checkuserinfo");
  const questions = getData("questionsAnswer");
  const pageAgree = getData("page_agree");
  const idc = getData("idc");
  const idcAddr = getData("f2_idc_address");
  const curAddr = getData("f2_current_address");
  const workAddr = getData("f2_workplace_address");
  const docAddr = getData("f2_document_address");
  const suit = getData("suitability");
  const status = getData("family_status");
  const childList = getData("childList");
  const career = getData("f3_career");
  const income = getData("f3_source_income");
  const purpose = getData("f3_purpose_invest");
  const asset = getData("f3_asset");
  const ats = getData("f7_ats");
  const bank_ats = getData("f7_bank_ats");
  const pass_dipchip = getData("pass_dipchip");
  const pass_ThaID = getData("pass_ThaID");
  let snapIdCard = getData("uploadImage");
  let uploadImgSign = getData("uploadImageSign");
  let uploadImageBookBank = getData("uploadImageBookBank");
  const REDIRECTED_KEY = "has_redirected";
  const checkJumpPage = async () => {
    await getImage();
    let productChoice = false;
    await callChoice(head_token).then((res) => {
      if (!isEmpty(res)) {
        res.forEach((e) => {
          e.items.forEach((item) => {
            if (item.selected === 1) productChoice = true;
          });
        });
      }
    });
    if (
      isEmpty(checkuserinfo) ||
      isEmpty(questions) ||
      isEmpty(pageAgree) ||
      pageAgree.termandcon !== 1 ||
      pageAgree.pdpa !== 1 ||
      isEmpty(snapIdCard) ||
      isEmpty(idc) ||
      isEmpty(idcAddr) ||
      isEmpty(curAddr) ||
      isEmpty(workAddr) ||
      isEmpty(docAddr) ||
      isEmpty(career) ||
      !productChoice ||
      isEmpty(suit) ||
      isEmpty(status) ||
      isEmpty(childList?.data) ||
      isEmpty(income) ||
      isEmpty(purpose) ||
      isEmpty(asset) ||
      isEmpty(uploadImgSign) ||
      isEmpty(ats) ||
      isEmpty(bank_ats) ||
      (isEmpty(uploadImageBookBank) && ats.f7_isother === "1") ||
      (pageAgree.ndid !== 1 && !pass_dipchip && !pass_ThaID)
    ) {
      return true;
    } else {
      return false;
    }
  };
  const getImage = async () => {
    setIsLoading(true);
    var postData = {
      head_token,
    };
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const queryString = new URLSearchParams(postData).toString();
    let getImage_url = `${Configs.baseURL}/api/getupload?` + queryString;
    try {
      await GlobalApi.get(getImage_url, header)
        .then(async (res) => {
          setIsLoading(false);
          if (res.data.api_status === "1") {
            if (res.data.data.length > 0) {
              res.data.data.forEach((element) => {
                if (element.tb_image_page === "uploadImage") {
                  snapIdCard = element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "eSignature") {
                  uploadImgSign =
                    element.tb_image_type + element.tb_image_base64;
                } else if (element.tb_image_page === "uploadImageBookBank") {
                  uploadImageBookBank =
                    element.tb_image_type + element.tb_image_base64;
                }
              });
            }
          }
        })
        .catch((er) => {
          setIsLoading(false);
        });
    } catch (error) {
      setIsLoading(false);
    }
    return;
  };
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  const handleChange = (value) => {
    if (isEmpty(value)) {
      setChecked(false);
      setIsRead(false);
    }
    setValueOption(value);
  };
  // const handleChangeCurrency = (value) => {
  //   if (isEmpty(value)) {
  //     setChecked(false);
  //     setIsRead(false);
  //   }
  //   setValueCurrency(value);
  // };
  const getProductChoice = async () => {
    try {
      setIsLoading(true);
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/product/selbyhead`,
        { head_token: head_token },
        header,
      )
        .then((res) => {
          if (res.status === API_CODE_SUCCESS) {
            setDataProduct(res?.data?.Data);
          }
          setIsLoading(false);
        })
        .catch((err) => {
          // console.log(err);
          setIsLoading(false);
        });
    } catch (error) {
      // console.log(error);
      setIsLoading(false);
    }
  };
  const cellStrategic = async (id, data_strate) => {
    setIsLoading(true);
    try {
      const header = {
        headers: {
          Accept: "application/json",
        },
      };
      await GlobalApi.post(
        `${Configs.baseAPIURL03}/form/strategic/selbyhead`,
        { head_token: HeaderManp.head_token, product_id: id },
        header,
      )
        .then(async (res) => {
          if (res.request.status !== API_CODE_SUCCESS) {
            setIsModelWaitText({
              ...isModelWaitText,
              title: res.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
              massage: res.data?.Data?.[0]?.[0]?.MsgDesc,
            });
            setIsModelWait(true);
          }
          setIsLoading(false);
          data_strate.push({ id: id, data: res?.data?.Data });
          setStrategic([...data_strate]);
        })
        .catch((e) => {
          if (!e.response) {
            setIsModelWaitText({
              ...isModelWaitText,
              title: "เกิดข้อผิดพลาด",
              massage: "กรุณาทำรายการใหม่อีกครั้ง",
            });
          } else {
            setIsModelWaitText({
              ...isModelWaitText,
              title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
              massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
            });
          }
          setIsModelWait(true);
          setIsLoading(false);
        });
    } catch (e) {
      if (!e.response) {
        setIsModelWaitText({
          ...isModelWaitText,
          title: "เกิดข้อผิดพลาด",
          massage: "กรุณาทำรายการใหม่อีกครั้ง",
        });
      } else {
        setIsModelWaitText({
          ...isModelWaitText,
          title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
          massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
        });
      }
      setIsModelWait(true);
      setIsLoading(false);
    }
  };
  // const cellCurrency = async () => {
  //   setIsLoading(true);
  //   try {
  //     await GlobalApi.get(`${Configs.baseAPIURL03}/constant/currency`)
  //       .then(async (res) => {
  //         if (res.request.status !== API_CODE_SUCCESS) {
  //           setIsModelWaitText({
  //             ...isModelWaitText,
  //             title: res.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
  //             massage: res.data?.Data?.[0]?.[0]?.MsgDesc,
  //           });
  //           setIsModelWait(true);
  //         }
  //         setIsLoading(false);
  //         setCurrency(res.data?.Data);
  //       })
  //       .catch((e) => {
  //         if (!e.response) {
  //           setIsModelWaitText({
  //             ...isModelWaitText,
  //             title: "เกิดข้อผิดพลาด",
  //             massage: "กรุณาทำรายการใหม่อีกครั้ง",
  //           });
  //         } else {
  //           setIsModelWaitText({
  //             ...isModelWaitText,
  //             title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
  //             massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
  //           });
  //         }
  //         setIsModelWait(true);
  //         setIsLoading(false);
  //       });
  //   } catch (e) {
  //     if (!e.response) {
  //       setIsModelWaitText({
  //         ...isModelWaitText,
  //         title: "เกิดข้อผิดพลาด",
  //         massage: "กรุณาทำรายการใหม่อีกครั้ง",
  //       });
  //     } else {
  //       setIsModelWaitText({
  //         ...isModelWaitText,
  //         title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
  //         massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
  //       });
  //     }
  //     setIsModelWait(true);
  //     setIsLoading(false);
  //   }
  // };
  const cellPost = async (selected) => {
    setIsLoading(true);
    let body = {
      head_token: HeaderManp.head_token,
      product_id: selected?.id,
      comfrimation: selected?.confirm,
      code: "PROD",
    };
    const product = [...productSelected];
    const productList = [];
    if (product.length > 0) {
      setProductSelectedDf([...product]);
    }
    product.forEach((pr) => {
      if (pr.id !== selected?.id) {
        productList.push(pr);
      }
    });
    try {
      await GlobalApi.post(`${Configs.baseAPIURL03}/form/signed_tnc/manp`, body)
        .then(async (res) => {
          if (res.request.status === API_CODE_SUCCESS) {
            if (
              res?.data?.Data?.[0]?.[0]?.IsSuccess === 1 &&
              selected?.confirm !== 0
            ) {
              setConsent({});
              setIsRead(false);
              setChecked(false);
              setCheckPost(true);
              setProductSelected(productList);
              if (valueOption) {
                setIsLoading(true);
                body = {
                  head_token: HeaderManp.head_token,
                  product_id: selected?.id,
                  strategic_id: valueOption,
                };
                try {
                  GlobalApi.post(
                    `${Configs.baseAPIURL03}/form/strategic/manp`,
                    body,
                  )
                    .then((res) => {
                      if (res.request.status === API_CODE_SUCCESS) {
                        if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
                          if (productList.length > 0) {
                            setValueOption("");
                          }
                        } else {
                          setIsModelWaitText({
                            ...isModelWaitText,
                            title: res?.data?.Data?.[0]?.[0]?.MsgDescTitle,
                            massage: res?.data?.Data?.[0]?.[0]?.MsgDesc,
                          });
                          setIsModelWait(true);
                        }
                      }
                      setIsLoading(false);
                    })
                    .catch((e) => {
                      if (!e.response) {
                        setIsModelWaitText({
                          ...isModelWaitText,
                          title: "เกิดข้อผิดพลาด",
                          massage: "กรุณาทำรายการใหม่อีกครั้ง",
                        });
                      } else {
                        setIsModelWaitText({
                          ...isModelWaitText,
                          title:
                            e.response.data?.Data?.[0]?.[0]?.MsgDesc
                              .MsgDescTitle,
                          massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
                        });
                      }
                      setIsModelWait(true);
                      setIsLoading(false);
                    });
                } catch (e) {
                  if (!e.response) {
                    setIsModelWaitText({
                      ...isModelWaitText,
                      title: "เกิดข้อผิดพลาด",
                      massage: "กรุณาทำรายการใหม่อีกครั้ง",
                    });
                  } else {
                    setIsModelWaitText({
                      ...isModelWaitText,
                      title:
                        e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
                      massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
                    });
                  }
                  setIsModelWait(true);
                  setIsLoading(false);
                }
              }
              // if (valueCurrency) {
              //   setIsLoading(true);
              //   body = {
              //     head_token: HeaderManp.head_token,
              //     product_id: selected?.id,
              //     currency_id: valueCurrency,
              //   };
              //   try {
              //     GlobalApi.post(
              //       `${Configs.baseAPIURL03}/form/currency/manp`,
              //       body
              //     )
              //       .then((res) => {
              //         if (res.request.status === API_CODE_SUCCESS) {
              //           if (res?.data?.Data?.[0]?.[0]?.IsSuccess === 1) {
              //             if (productList.length > 0) {
              //               setValueCurrency("");
              //             }
              //           } else {
              //             setIsModelWaitText({
              //               ...isModelWaitText,
              //               title: res?.data?.Data?.[0]?.[0]?.MsgDescTitle,
              //               massage: res?.data?.Data?.[0]?.[0]?.MsgDesc,
              //             });
              //             setIsModelWait(true);
              //           }
              //         }
              //         setIsLoading(false);
              //       })
              //       .catch((e) => {
              //         if (!e.response) {
              //           setIsModelWaitText({
              //             ...isModelWaitText,
              //             title: "เกิดข้อผิดพลาด",
              //             massage: "กรุณาทำรายการใหม่อีกครั้ง",
              //           });
              //         } else {
              //           setIsModelWaitText({
              //             ...isModelWaitText,
              //             title:
              //               e.response.data?.Data?.[0]?.[0]?.MsgDesc
              //                 .MsgDescTitle,
              //             massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
              //           });
              //         }
              //         setIsModelWait(true);
              //         setIsLoading(false);
              //       });
              //   } catch (e) {
              //     if (!e.response) {
              //       setIsModelWaitText({
              //         ...isModelWaitText,
              //         title: "เกิดข้อผิดพลาด",
              //         massage: "กรุณาทำรายการใหม่อีกครั้ง",
              //       });
              //     } else {
              //       setIsModelWaitText({
              //         ...isModelWaitText,
              //         title:
              //           e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
              //         massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
              //       });
              //     }
              //     setIsModelWait(true);
              //     setIsLoading(false);
              //   }
              // }
            } else if (selected?.confirm !== 0) {
              setIsModelWaitText({
                ...isModelWaitText,
                title: res?.data?.Data?.[0]?.[0]?.MsgDescTitle,
                massage: res?.data?.Data?.[0]?.[0]?.MsgDesc,
              });
              setIsModelWait(true);
            }
          }
          setIsLoading(false);
        })
        .catch((e) => {
          if (!e.response) {
            setIsModelWaitText({
              ...isModelWaitText,
              title: "เกิดข้อผิดพลาด",
              massage: "กรุณาทำรายการใหม่อีกครั้ง",
            });
          } else {
            setIsModelWaitText({
              ...isModelWaitText,
              title: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
              massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
            });
          }
          setIsModelWait(true);
          setIsLoading(false);
        });
    } catch (e) {
      if (!e.response) {
        setIsModelWaitText({
          ...isModelWaitText,
          title: "เกิดข้อผิดพลาด",
          massage: "กรุณาทำรายการใหม่อีกครั้ง",
        });
      } else {
        setIsModelWaitText({
          ...isModelWaitText,
          title: e.response.data?.Data?.[0]?.[0]?.MsgDesc.MsgDescTitle,
          massage: e.response.data?.Data?.[0]?.[0]?.MsgDesc,
        });
      }
      setIsModelWait(true);
      setIsLoading(false);
    }
  };
  const popup = async (e) => {
    let selected = productSelected.find((e) => e.confirm === 0);
    if (selected) {
      selected = {
        ...selected,
        confirm: 0,
      };
    } else {
      selected = productSelectedDf.find((e) => e.confirm === 0);
      selected = {
        ...selected,
        confirm: 0,
      };
    }
    cellPost(selected);
    setValueModal({
      imgError: true,
      imgFinished: false,
      title: "ขออภัย ท่านไม่สามารถเปิดบัญชีออนไลน์ได้",
      massage:
        "กรุณาติดต่อ DAOL Contact Center<br>0 2351 1800 หากต้องการดำเนินการต่อ กรุณาคลิกยอมรับ",
      btnPrimary: "ยอมรับ",
      again: e === 0 ? true : false,
    });
    setIsModal(true);
    return;
  };
  const allowClick = (e) => {
    let selected = productSelected.find((e) => e.confirm === 0);
    if (selected) {
      selected = {
        ...selected,
        confirm: 1,
      };
    } else {
      selected = productSelectedDf.find((e) => e.confirm === 0);
      selected = {
        ...selected,
        confirm: 1,
      };
    }
    if (strategic?.find((op) => op.id === selected?.id)?.data.length === 0) {
      cellPost(selected);
    } else if (
      strategic?.find((op) => op.id === selected?.id)?.data.length > 0 &&
      valueOption
    ) {
      cellPost(selected);
    } else {
      // popupStrategic();
      console("strategic");
    }
  };
  const setProductConsent = async (product) => {
    const header = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    await GlobalApi.get(
      Configs.baseURL + "/api/consent?id=" + product?.id,
      header,
    )
      .then(async (res) => {
        setConsent({
          checkboxText: "",
          termConText: "",
          titleText: "",
          btnOk: "",
          btnCancel: "",
          id: "",
          group: "",
          name: "",
        });
        res?.data?.data.forEach((row) => {
          setConsent({
            checkboxText: row?.checkBox ?? "",
            termConText: row?.detail ?? "",
            titleText: row?.title ?? "",
            btnOk: row?.okBtn ?? "",
            btnCancel: row?.cancelBtn ?? "",
            id: product.id,
            group: product.group,
            name: product.name,
          });
        });
        setIsRead(false);
        setChecked(false);
      })
      .catch((error) => {
        var mss = "ไม่สามารถทำรายการได้ กรุณาทำรายการใหม่อีกครั้ง";
        var title_mss = "เกิดข้อผิดพลาด";
        setIsModelWaitText({
          ...isModelWaitText,
          title: title_mss,
          massage: mss,
        });
        setIsModelWait(true);
      });
  };
  const setChoiceStregic = (data) => {
    let list = [];
    data?.forEach((row) => {
      list.push({ label: row.name, value: row.id });
    });
    return list;
  };
  const setChoiceCurrency = (data) => {
    let list = [];
    data?.forEach((row) => {
      list.push({ label: row.Name, value: row.Id });
    });
    return list;
  };
  useEffect(() => {
    storeData("prodConsent", false);
    checkJumpPage().then((res) => {
      if (res) setJumpPage(true);
    });
  }, []);
  useEffect(() => {
    if (dataProduct.length > 0) {
      const productItem = [];
      const data_strate = [];
      dataProduct.forEach((product) => {
        product.items.forEach((item) => {
          if (item.selected === 1) {
            if (
              item.id === 3 ||
              item.id === 4 ||
              item.id === 23 ||
              item.id === 12 ||
              item.id === 37 ||
              item.id === 5 ||
              item.id === 13 ||
              item.id === 35 ||
              item.id === 44 ||
              item.id === 43 ||
              item.id === 59
            ) {
              cellStrategic(item?.id, data_strate);
              productItem.push({
                ...item,
                confirm: 0,
              });
            }
            setCheckPost(true);
          }
        });
      });
      if (productItem.length > 0) {
        storeData("tcconfirm", { confirm: 0 });
      } else {
        storeData("tcconfirm", { confirm: 1 });
      }
      setProductSelected(productItem);
    }
  }, [dataProduct]);

  useEffect(() => {
    const findGTokenSelected = dataProduct.some((group) =>
      group.items?.some(
        (product) => product.id === 59 && product.selected === 1,
      ),
    );
    if (productSelected.length > 0) {
      setProductConsent(productSelected.find((e) => e.confirm === 0));
    } else if (productSelected.length === 0 && checkPost) {
      storeData("prodConsent", true);
      if (findGTokenSelected) {
        props.history.push("gtoken_consent");
      } else {
        props.history.push("tc_confirm");
      }
    }
  }, [productSelected]);
  useEffect(() => {
    getProductChoice();
    // cellCurrency();
  }, []);

  useEffect(() => {
    // ถ้ากด back กลับมา → ไป index
    const hasRedirected = localStorage.getItem(REDIRECTED_KEY);
    if (hasRedirected) {
      localStorage.removeItem(REDIRECTED_KEY);
      props.history.replace("/");
      return;
    }

    // tab อื่น redirect ตาม
    const handleStorage = (e) => {
      if (e.key === STORAGE_KEY && e.newValue) {
        try {
          const data = JSON.parse(e.newValue);
          if (data.type === "REDIRECT") {
            localStorage.setItem(REDIRECTED_KEY, "true");
            window.location.replace(data.url);
          }
        } catch (err) {}
      }
    };

    // bfcache (Safari)
    const handlePageShow = (e) => {
      if (e.persisted && localStorage.getItem(REDIRECTED_KEY)) {
        localStorage.removeItem(REDIRECTED_KEY);
        props.history.replace("/");
      }
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);
  return (
    <>
      {jumpPage ? (
        <Grid className="app-splash-screen"></Grid>
      ) : (
        <>
          <HeaderPage
            title={translations?.[lang]?.product_consent?.title}
            onChangeLang={(e) => setLang(e)}
            clickBack={(e) => (e ? props.history.push("/summary") : "")}
          />
          <Loading status={isLoading} />
          <DialogWait
            open={isModelWait}
            isModel={setIsModelWait}
            title={isModelWaitText.title}
            massage={isModelWaitText.massage}
            btn={isModelWaitText.btn}
          />
          <DialogCustoms
            open={isModal}
            isModel={setIsModal}
            imgModalError={valueModal.imgError}
            imgModalFinished={valueModal.imgFinished}
            switchType={(e) => {
              if (e && valueModal?.again) {
                props.history.push("");
              }
            }}
            title={valueModal.title}
            massage={valueModal.massage}
            btnPrimary={valueModal.btnPrimary}
          />
          <Grid className="background-bg">
            <Grid className="section-consent">
              <Grid className={isMobile ? "box-content-mb" : "box-content"}>
                <Grid container className="box-content-main" columns={16}>
                  {!isMobile && (
                    <Grid item xs={7} className="box-left">
                      <BoxLeftContent
                        translations={translations?.[lang]?.product_consent}
                        clickBack={(e) => props.history.push("/summary")}
                      />
                    </Grid>
                  )}
                  <Grid
                    item
                    xs={mb}
                    className={isMobile ? "box-right-mb" : "box-right"}
                  >
                    <Grid className="content">
                      <Grid className="content-main">
                        <Grid
                          className="box-right-content pb-3"
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}
                        >
                          {" "}
                          <HeaderRight title={"ข้อตกลงและเงื่อนไข"} />
                          <PanelScrollBar
                            content={
                              <Grid container>
                                <Grid className="sub-title">
                                  <Typography
                                    className={clsx(
                                      "box-title text-left font-20",
                                    )}
                                    dangerouslySetInnerHTML={{
                                      __html: consent.titleText,
                                    }}
                                  />
                                </Grid>

                                {consent.name ===
                                  "DAOL SEC Smart Foreign ประเภท Platform" ||
                                consent.name ===
                                  "DAOL SEC Smart Foreign ประเภท Smart Trade" ? (
                                  <></>
                                ) : (
                                  // <Grid className="input-form fullWidth">
                                  //   <Grid className="font-18 text-primary font-DBHeavent font-weight-bold">
                                  //     กรุณาเลือกสกุลเงินลงทุนที่ประสงค์จะใช้ลงทุน
                                  //   </Grid>
                                  //   <FormControl
                                  //     variant="standard"
                                  //     fullWidth
                                  //     error
                                  //   >
                                  //     <Autocomplete
                                  //       options={setChoiceCurrency(currency)}
                                  //       //  value={}
                                  //       getOptionLabel={(option) =>
                                  //         option.label ? option.label : ""
                                  //       }
                                  //       onChange={(e, value) => {
                                  //         handleChangeCurrency(value?.value);
                                  //       }}
                                  //       renderInput={(params) => (
                                  //         <TextField
                                  //           {...params}
                                  //           variant="standard"
                                  //           label="กรุณาเลือกสกุลเงิน"
                                  //           required
                                  //         />
                                  //       )}
                                  //     />
                                  //   </FormControl>
                                  // </Grid>
                                  ""
                                )}
                                {strategic?.find((op) => op.id === consent.id)
                                  ?.data.length > 0 && (
                                  <Grid className="input-form fullWidth">
                                    <Grid className="font-18 text-primary font-DBHeavent font-weight-bold">
                                      กรุณาเลือกประเภทบริการ DAOL SEC Smart Algo
                                      แบบใช้กลยุทธ์ลงทุนสำเร็จ
                                    </Grid>
                                    <FormControl
                                      variant="standard"
                                      fullWidth
                                      error
                                    >
                                      <Autocomplete
                                        options={setChoiceStregic(
                                          strategic?.find(
                                            (op) => op.id === consent.id,
                                          ).data,
                                        )}
                                        //  value={}
                                        getOptionLabel={(option) =>
                                          option.label ? option.label : ""
                                        }
                                        onChange={(e, value) => {
                                          handleChange(value?.value);
                                        }}
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            variant="standard"
                                            label="กรุณาเลือกกลยุทธ์"
                                            required
                                          />
                                        )}
                                      />
                                    </FormControl>
                                    <Grid className="pt-2 font-DBHeavent text-black font-20">
                                      {
                                        strategic
                                          ?.find((op) => op.id === consent.id)
                                          ?.data?.find(
                                            (opt) => opt.id === valueOption,
                                          )?.detail
                                      }
                                    </Grid>
                                    <Grid className={classes.content}>
                                      <Grid
                                        className={clsx(
                                          "font-DBHeavent",
                                          "text-black",
                                          "font-20",
                                          !valueOption && "hide",
                                        )}
                                        dangerouslySetInnerHTML={{
                                          __html: consent.termConText,
                                        }}
                                      />
                                    </Grid>
                                  </Grid>
                                )}
                                {strategic?.find((op) => op.id === consent.id)
                                  ?.data.length === 0 && (
                                  <>
                                    {consent.name ===
                                      "DAOL SEC Smart Foreign ประเภท Platform" ||
                                    consent.name ===
                                      "DAOL Smart Foreign ประเภท Smart Trade" ? (
                                      <>
                                        {/* {valueCurrency && (
                                          <Grid className={classes.content}>
                                            <Grid
                                              className={clsx(
                                                "font-DBHeavent",
                                                "text-black",
                                                "font-20"
                                              )}
                                              dangerouslySetInnerHTML={{
                                                __html: consent.termConText,
                                              }}
                                            />
                                          </Grid>
                                        )} */}
                                      </>
                                    ) : (
                                      <>
                                        <Grid className={classes.content}>
                                          <Grid
                                            className={clsx(
                                              "font-DBHeavent",
                                              "text-black",
                                              "font-20",
                                            )}
                                            dangerouslySetInnerHTML={{
                                              __html: consent.termConText,
                                            }}
                                          />
                                        </Grid>
                                      </>
                                    )}
                                  </>
                                )}
                              </Grid>
                            }
                            confirmRead={setIsRead}
                          />
                          {/* check box content */}
                          <Grid>
                            <Grid className="checkbox-consent">
                              <Checkbox
                                className="check-box-deco"
                                sx={{
                                  color: "#023b66",
                                  opacity: "0.8",
                                  "&.Mui-checked": {
                                    color: "#023b66",
                                    opacity: "0.8",
                                  },
                                }}
                                disabled={!isRead}
                                checked={checked}
                                onChange={handleCheck}
                              />
                              <Grid
                                onClick={(e) => {
                                  if (isRead) {
                                    setChecked(!checked);
                                  } else {
                                    setChecked(false);
                                  }
                                }}
                                className={clsx(
                                  classes.content,
                                  isMobile
                                    ? "content-check-box-mb"
                                    : "content-check-box",
                                  "text-left font-18 product-choice-p",
                                  !isRead ? "checkbox-unread" : "checkbox-read",
                                )}
                                dangerouslySetInnerHTML={{
                                  __html: consent.checkboxText,
                                }}
                              ></Grid>
                            </Grid>
                          </Grid>{" "}
                          <Grid className={clsx(!isMobile && "pt-1")}>
                            <Grid
                              container
                              direction="row"
                              justifyContent="space-between"
                              alignItems="center"
                              spacing={2}
                            >
                              <Grid item xs={6}>
                                <Button
                                  className={clsx(
                                    "btn-secondary font-20",
                                    !checked ? "disabled" : "",
                                  )}
                                  disabled={!checked}
                                  onClick={() => popup("0")}
                                >
                                  {consent.btnCancel}
                                </Button>
                              </Grid>
                              <Grid item xs={6}>
                                <Button
                                  className={clsx(
                                    !checked
                                      ? "disabled-btn-right"
                                      : "enabled-btn-right",
                                    "btn-next font-20",
                                  )}
                                  disabled={!checked}
                                  onClick={allowClick}
                                >
                                  {consent.btnOk}
                                </Button>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};
export default memo(ProductsConsent);
